import { Validator } from "fluentvalidation-ts";
import { matchIsValidTel } from "mui-tel-input";

type Contract = {
  asset:number;
  maintenanceCompany:number;
  contractLink:string;
};

class ContractValidator extends Validator<Contract> {
  constructor() {
    super();

    this.ruleFor("asset")
      .notNull()
     .withMessage("Campo obbligatorio");
   

     this.ruleFor("maintenanceCompany")
     .notNull()
    .withMessage("Campo obbligatorio");

    this.ruleFor("contractLink")
    .notNull()
   .withMessage("Campo obbligatorio");



  }
  
}

export default ContractValidator;
